$(document).ready(function () {
    if ($('#page').attr('data-page-id') === 'cvs') {
        let cvsTable = $('#cvs');
        let dateTableCvs = cvsTable.DataTable({
            ajax: {
                url: 'get-cvs',
                data: function(d){
                    d.filters = {
                        'orgs.id': $('#orgFilter').val(),
                        'events.id': $('#eventFilter').val(),
                        'candidates.candidate_short_cv_checked': $('#cvFilter').val()
                    }
                }
            },
            // filter: {'orgs.id': '3'},
            dataSrc: 'data',
            // processing: true,
            serverSide: true,
            responsive: true,
            lengthMenu: [[25, 50, -1], [25, 50, "All"]],
            columns: [
                { data: 'candidate_id', name: 'candidate_id', responsivePriority: 1 },
                { data: 'event_name', name: 'event_name', responsivePriority: 1 },
                { data: 'candidate_name', name: 'candidate_name', responsivePriority: 1 },
                { data: 'candidate_first_name', name: 'candidate_first_name' },
                { data: 'org_name', name: 'org_name' },
                { data: 'action', name: 'action', searchable: false, sortable: false, responsivePriority: 1 }
            ]
        });

        $('.filter').change(function (e) {
            let orgFilter = $('#orgFilter').val().length === 0 ? '0' : $('#orgFilter').val();
            let eventFilter = $('#eventFilter').val().length === 0 ? '0' : $('#eventFilter').val();
            let link = orgFilter + '/' + eventFilter;

            if ($('#cvFilter').val().length > 0) {
                link +=  '/' + $('#cvFilter').val();
            }

            $('#exportLink').attr({href: '/export/' + link })
            $('#csvLink').attr({href: '/exportcsv/' + link })
            dateTableCvs.draw();
        });

        cvsTable.on('click', 'tbody tr', function (v) {
            let id = $(v.target).attr('data-candidate-id');
            let data = dateTableCvs.row(this).data();
            if (data) {
                if ($(v.target).hasClass('unchecked') === true || $(v.target).hasClass('checked') === true) {
                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    });

                    $.ajax({
                        type: "POST",
                        data: {"_token": $('meta[name="csrftoken"]').attr('content')},
                        url: '/cv-check/' + id,
                        success: function(msg) {
                            dateTableCvs.ajax.reload();
                            if (msg.result === true) {
                                $('body').notification({
                                    type: 'info',
                                    title: '',
                                    message: 'Der Status wurde erfolgreich geändert.',
                                    autoClose: 4000
                                });
                            } else {
                                $('body').notification({
                                    type: 'error',
                                    title: 'Fehler',
                                    message: 'Der Status konnte leider nicht geändert werden.',
                                });
                            }
                        }
                    });
                }
            }
        });
    }
});
